import r, { useState as a, useEffect as l, useMemo as c } from "react";
import { ScopeModel as s } from "../../../../../api/models/scope/scope.model.js";
import { useNavigation as u } from "../../../Navigation/hooks/useNavigation.js";
const f = {
  design: {
    generalHightlight: "#EA565C",
    hightLighHightlight: "#EA565C",
    accentColor: "#da81de",
    header: {
      textColor: "#FFF",
      primaryColor: "#242323"
    },
    content: {
      backgroundColor: "#FFF",
      textColor: "#242323",
      borderColor: "#dddddd"
    }
  },
  utmReferral: "",
  scope: new s()
}, p = r.createContext({});
function g(e) {
  const {
    isNavigationOpen: t
  } = u(), [o, n] = a(!1), {
    children: d
  } = e;
  l(() => {
    o || t ? (typeof window.scrollTo == "function" && window.scrollTo({
      top: 0,
      behavior: "smooth"
    }), document.body.style.overflow = "hidden") : document.body.style.overflow = "";
  }, [o, t]);
  const i = c(() => ({
    ...f,
    ...e,
    isDropdownMenuOpen: o,
    setIsDropdownMenuOpen: n
  }), [
    o
  ]);
  return /* @__PURE__ */ r.createElement(p.Provider, { value: i }, d);
}
export {
  p as NavbarContext,
  g as NavbarProvider
};
//# sourceMappingURL=context.js.map
